<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16">
    <div class="cf-flex cf-flex--align-center cf-flex--justify-center">
      <loyalty-banner-image />
    </div>

    <cf-verify-account-cta />

    <loyalty-rewards-points-summary />

    <template v-if="isEnrolledInLoyalty">
      <gift-loyalty-points-cta v-if="isPointsGiftingEnabled" />

      <scan-to-earn-cta v-if="isScanToEarnEnabled" />

      <refer-a-friend-cta v-if="isReferAFriendEnabled" />
    </template>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import LoyaltyBannerImage from './loyalty-banner-image/index.vue';
  import LoyaltyRewardsPointsSummary from './loyalty-rewards-points-summary/index.vue';
  import GiftLoyaltyPointsCta from './gift-loyalty-points-cta/index.vue';
  import ReferAFriendCta from './refer-a-friend-cta/index.vue';
  import ScanToEarnCta from './scan-to-earn-cta/index.vue';

  import CfVerifyAccountCta from '@/view/components/globals/cf-verify-account-cta/index.vue';


  export default {
    name: 'LoyaltySummary',

    components: {
      LoyaltyBannerImage,
      LoyaltyRewardsPointsSummary,
      CfVerifyAccountCta,
      GiftLoyaltyPointsCta,
      ScanToEarnCta,
      ReferAFriendCta
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('offers', ['loyalty', 'offers']),

      isEnrolledInLoyalty() {
        return this.loyalty.isEnrolled;
      },

      isLoyaltyCheckInEnabled() {
        return this.merchant.options.loyaltyOptions.loyaltyCheckInEnabled;
      },

      isLoyaltyReceiptScanningEnabled() {
        return this.merchant.options.loyaltyOptions.loyaltyReceiptScanningEnabled;
      },

      isScanToEarnEnabled() {
        return (this.isLoyaltyCheckInEnabled || this.isLoyaltyReceiptScanningEnabled) && !this.merchant.options.loyaltyOptions.loyaltyCardCheckInEnabled;
      },

      isReferAFriendEnabled() {
        return !!this.merchant.options.loyaltyOptions.referralOptions?.profileReferralUIEnabled;
      },

      isPointsGiftingEnabled() {
        const hasPrimaryCurrency = this.loyalty.primaryLedger?.currency;

        if (hasPrimaryCurrency) {
          const { isActive = false, minPointsPerGift = 1 } = this.loyalty.primaryLedger.currency.pointGiftPolicy || { isActive: false, minPointsPerGift: 1 };

          return isActive && this.loyalty.currentBalance >= minPointsPerGift;
        }

        return false;
      },

      pointsGifitingCta() {
        return this.content.Loyalty.metadata.giftPointsButtonCta;
      }
    }
  };
</script>
